import type { ThemeOptions, AlertColor } from '@mui/material';

const autoHideDuration = 30 * 1000; // 30 seconds

const SnackbarTheme: ThemeOptions['components'] = {
  MuiSnackbar: {
    defaultProps: {
      autoHideDuration,
      anchorOrigin: { vertical: 'bottom', horizontal: 'right' },
    },
  },
};

export default SnackbarTheme;
